<template lang="pug">
  #CustomerTempTextModel.CustomerModel.CustomerModel-tempTextModel(
    :class="{ 'CustomerModel-active': showModel }",
    :style="[{Zindex: Zindex}, modelCSS]"
  )
    .p-3
      .row.align-items-start.mb-2
        .col-10
          h2.mb-0 {{ editData ? '編輯訊息模板' : title }}
        .col-2
          img.rounded-circle.closeIcon(
            v-lazy="iconUrl.IconClose",
            fluid,
            alt="Close Icon",
            @click="closeModel()"
          )
      .content.mb-2
        p.mb-3 訊息內容：(請輸入文字)
        b-form-textarea(
          rows="10",
          v-model="text"
        )
        small.text-muted.text-right.d-block 文字數：{{ text ? text.length : 0 }}
    .row.no-gutters
      .col-6
        button.btn.btn-block.btn-light(
          type="button",
          @click="closeModel()",
          class="rounded-0 border border-gray"
        ) 返回上頁
      .col-6
        button.btn.btn-block.btn-primary(
          type="button",
          @click="submitHandler()",
          class="rounded-0 border border-gray"
        ) 儲存

</template>

<script>
import IconCloseUrl from '@/assets/images/icon/icon_close.png';

export default {
  name: 'TempTextModel',
  props: {
    title: {
      type: String,
      default: ''
    },
    Zindex: {
      type: String,
      default: '15px'
    },
    modelCSS: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      iconUrl: {
        IconClose: IconCloseUrl
      },
      showModel: false,
      text: null,
      editData: null,
      mode: null
    };
  },
  mounted() {
    const vm = this;
    vm.$EventBus.$on('openTempTextModel', (data) => {
      if (data) {
        vm.editData = data.data;
        vm.mode = data.mode;
      } else {
        vm.editData = null;
      }
      vm.openModel();
    });
  },
  methods: {
    initHandler() {
      if (this.editData) {
        this.text = this.editData.push_format.text;
      } else {
        this.text = null;
        this.mode = null;
      }
    },
    openModel() {
      this.initHandler();
      this.showModel = true;
    },
    closeModel() {
      this.$emit('scrollToTarget');
      this.initHandler();
      this.showModel = false;
    },
    submitHandler() {
      const vm = this;

      if (!vm.text || vm.text.length === 0) {
        vm.$swal.fire({
          icon: 'error',
          title: '文字訊息內容尚未填寫'
        });
      } else {
        let apiTarget = 'createTempHandler';
          const sendData = {
            type: 'text',
            text: vm.text
          };
          let successText = '訊息模板新增成功';

        // 判斷是否是編輯
        if (vm.editData && vm.mode === 'edit') {
          apiTarget = 'updateTempHandler';
          sendData.id = vm.editData.id;
          successText = '訊息模板編輯成功';
        }

        vm.$swal.fire({
          title: '請稍候，\n模板儲存中',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });

        vm.$store.dispatch(`sa_temp/${apiTarget}`, sendData)
          .then(() => {
            vm.$emit('changeTypeHandler');
            vm.$swal.close();
            vm.closeModel();
            vm.$snotify.success(null, `${successText}`);
          });
      }
    }
  },
  beforeDestroy() {
    this.$EventBus.$off('openTempTextModel');
  }
};
</script>

<style>

</style>
